import * as z from "zod";

// Public pre-auth lookup: resolves a partner referralToken to co-brand /signup.
export const getSignupPartnerBranding = {
  name: "getSignupPartnerBranding" as const,
  input: z.object({ referralToken: z.string().max(64) }),
  output: z
    .object({
      partnerName: z.string().max(256),
      logoUrl: z.string().max(2048).nullable(),
    })
    .nullable(),
};
